var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._b({staticClass:"inputWidth",attrs:{"clearable":""},on:{"change":_vm.change}},'el-select',_vm.$attrs,false),_vm._l((_vm.renderOptions),function(item,index){return _c('el-option',{key:index,attrs:{"value":item.value,"label":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }